<h2 mat-dialog-title>
    <span>Alterar senha</span>
</h2>
<div mat-dialog-content>
    <form class="form" #form="ngForm">
        <mat-form-field class="page-form-control">
            <input matInput type="password" placeholder="Senha" [(ngModel)]="senha" name="senha" required>
        </mat-form-field>

        <mat-form-field class="page-form-control">
            <input matInput type="password" placeholder="Confirmar senha" [(ngModel)]="confirmarSenha"
                name="confirmarSenha" required>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-button cdkFocusInitial (click)="dismiss(false)">Cancelar</button>
    <button mat-button (click)="submit(form)">OK</button>
</div>